import React from 'react'
import { throttle, debounce, find, forEach, remove } from 'lodash'

import Header from '../header/'
import Sidebar from '../sidebar/'
import Inspector from 'Components/inspector'
import ResponsiveControls from 'Components/responsive-controls'
import DisableLinkClick from 'Components/disable-link-click'
// import Preloader from 'Components/preloader'

import getSelector from 'Functions/get-selector'
import getGeneratedCss from 'Functions/get-generated-css'
import { optimizeCodeWithPostCSS } from 'Functions/on-option-change'
// import onCodeEditorChange from 'Functions/on-code-editor-change'
import replaceSelectorInCss from 'Functions/replace-selector-in-css'
import { cacheCssValuesForSelector } from 'Functions/get-css-value'
import CodeManager from 'Functions/code-manager'
import 'Functions/get-all-media-queries'
// import 'Functions/disable-link-click'

// import 'default-passive-events'
// ↑ Required to fix issues passive scroll listening events: https://github.com/zzarcon/default-passive-events
// Disabled as it breaks slider.

/* Import CSS */
import './index.scss'

class App extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			// Inspector:
			selectorChanged: false,
			inspectorActive: false,

			// Selected element data:
			selectedEl: false,
			cssSelectorFull: false,
			cssSelectorCustom: false,
			cssCurrentPseudoClass: 'none',

			// Interface:
			sidebarTab: false,
			sidebarPanel: false,
			isFullScreen: false,

			// State:
			codeChanged: false,
			isSaving: false,
			initCssOptimization: false, // On editor 1st load we optimize CSS code.
			cssCacheReady: false,

			// Responsive:
			responsiveView: false,
			currentMediaType: false, // 'max-width',
			currentPreviewWidth: false,
			// mediaQueries: [],
		}

		this.codeManager = false
	}

	componentWillMount() {
		window.Stylist.codeChanged = () => {
			this.setState( {
				codeChanged: true,
			} )
		}

		window.Stylist.setCssCacheReady = ( newValue = true ) => {
			this.setState( {
				cssCacheReady: newValue,
			} )
		}

		window.Stylist.isInitCssOptimized = () => {
			return this.state.initCssOptimization
		}

		window.Stylist.setInitCssOptimized = ( newValue = true ) => {
			this.setState( {
				initCssOptimization: true
			} )
		}

		window.Stylist.changeSelector = ( newSelector ) => {
			this.onCssSelectorChange( newSelector )
		}

		// Allow legacy code to access (read only) responsiveView value.
		window.Stylist.responsiveView = () => {
			return this.state.responsiveView
		}

		// Allow legacy code to acces current media type.
		window.Stylist.currentMediaType = () => {
			return this.state.currentMediaType
		}

		window.Stylist.setCurrentMediaType = ( newType ) => {
			this.setState( {
				currentMediaType: newType,
			} )
		}

		window.Stylist.setCurrentPreviewWidth = ( newWidth ) => {
			this.throttledOnCurrentPreviewWidth( newWidth )
		}
	}

	throttledOnCurrentPreviewWidth = debounce(
		( newWidth ) => {
			// this.onCurrentPreviewWidth( newWidth )
			const savedSidebarTab = this.state.sidebarTab
			this.setState( {
				currentPreviewWidth: newWidth,
				sidebarTab: false, // Disable sidebar to reset panel controls.
			}, () => {
				// After.
				this.setState( {
					sidebarTab: savedSidebarTab
				} )
			} )
		}, 500, {
			leading: false,
			trailing: true
		} )

	customCssLinter = ( cm, updateLinting, options ) => {
		// https://github.com/codemirror/CodeMirror/blob/master/addon/lint/lint.js

		// call the built in css linter from addon/lint/css-lint.js
		const errors = wp.CodeMirror.lint.css( cm )

		// Remove unwanted errors.
		// For time being we remove all the warnings altogether as most of them,
		// makes no sense in our case.
		remove( errors, function( err ) {
			if ( err.message && err.severity === 'warning' ) {
			// if ( err.message && err.message.includes( 'background-position-' ) ) {
				return true
			}
		} );

		updateLinting( errors )
	}

	componentDidMount = () => {
		this.onInspectorToggle()
		// Activate CSS code manager.
		CodeManager.init()

		/*
		// Stylist Logo
		const stylistLogo = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="82" height="15" viewBox="0 0 82 15" version="1.1"><title>Group 4 Copy 2</title><desc>Created with Sketch.</desc><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Group-4-Copy-2"><path d="M77.33 4.09L75.88 9.6C75.81 9.87 75.63 10 75.36 10L74.07 10C73.94 10 73.83 9.95 73.73 9.86 73.63 9.77 73.58 9.66 73.58 9.53L73.58 6.07C73.59 5.54 73.6 5.26 73.6 5.23L73.45 5.23C73.39 5.57 73.34 5.84 73.29 6.06L72.38 9.59C72.31 9.86 72.13 10 71.86 10L70.55 10C70.42 10 70.3 9.95 70.21 9.86 70.11 9.77 70.07 9.66 70.07 9.54L70 4.09 71.45 4.09 71.34 7.96C71.33 8.06 71.32 8.22 71.31 8.43 71.3 8.64 71.29 8.79 71.29 8.89L71.44 8.89C71.5 8.51 71.58 8.18 71.66 7.89L72.54 4.54C72.61 4.24 72.79 4.09 73.07 4.09L74.17 4.09C74.3 4.09 74.41 4.13 74.49 4.23 74.58 4.33 74.63 4.45 74.63 4.6L74.69 7.97C74.7 8.28 74.7 8.58 74.69 8.89L74.84 8.89C74.89 8.54 74.95 8.22 75.02 7.92L75.88 4.09 77.33 4.09ZM77.22 10L77.98 4.09C78.48 4.03 79.18 4 80.07 4 80.85 4 81.39 4.15 81.68 4.45 81.96 4.74 82.06 5.27 81.97 6.04 81.87 6.79 81.68 7.3 81.38 7.56 81.08 7.82 80.59 7.95 79.89 7.95 79.59 7.95 79.27 7.93 78.95 7.88L78.69 10 77.22 10ZM79.1 6.78L79.77 6.78C80.03 6.78 80.21 6.73 80.31 6.62 80.4 6.52 80.47 6.29 80.52 5.92 80.56 5.63 80.54 5.43 80.47 5.33 80.41 5.23 80.26 5.17 80.03 5.17L79.3 5.18 79.1 6.78Z" id="WP-Copy-3" fill="#FFFFFF"/><path d="M23.61 8.17L21.7 7.29C20.91 6.93 20.39 6.49 20.13 5.99 19.86 5.49 19.78 4.87 19.86 4.14 20 3.04 20.4 2.28 21.04 1.88 21.69 1.47 22.7 1.27 24.08 1.27 25.44 1.27 26.62 1.43 27.62 1.76L27.36 3.6C25.57 3.57 24.44 3.56 23.95 3.56 23.48 3.56 23.16 3.6 22.98 3.68 22.8 3.76 22.69 3.95 22.64 4.25 22.6 4.47 22.62 4.64 22.72 4.76 22.81 4.87 23.03 5 23.37 5.14L25.14 5.93C25.95 6.28 26.48 6.7 26.73 7.18 26.98 7.65 27.06 8.3 26.98 9.1 26.84 10.27 26.47 11.06 25.87 11.48 25.28 11.89 24.25 12.1 22.8 12.1 21.52 12.1 20.25 11.94 19 11.63L19.27 9.63C21.28 9.68 22.41 9.71 22.67 9.71 23.22 9.71 23.61 9.66 23.82 9.56 24.04 9.47 24.17 9.27 24.22 8.98 24.26 8.76 24.23 8.6 24.15 8.5 24.07 8.4 23.88 8.29 23.61 8.17ZM32.06 6.11L31.61 9.35C31.57 9.59 31.59 9.75 31.66 9.82 31.73 9.9 31.89 9.94 32.15 9.94L33.07 9.94 33.21 11.76C32.63 11.99 31.87 12.1 30.93 12.1 30.19 12.1 29.63 11.9 29.25 11.51 28.87 11.11 28.72 10.59 28.82 9.92L29.38 6.11 28.08 6.11 28.29 4.46 29.63 4.39 29.93 2.36 32.6 2.36 32.31 4.39 34.2 4.39 33.97 6.11 32.06 6.11ZM40.14 4.39L43.03 4.39C42.85 5.58 42.51 6.86 42 8.25 41.49 9.64 41.03 10.7 40.6 11.45 39.86 12.7 39.04 13.6 38.13 14.17 37.22 14.73 36.17 15.01 34.97 15L34.74 13.44C34.78 13.43 34.9 13.4 35.08 13.34 35.27 13.28 35.39 13.24 35.44 13.22 35.49 13.21 35.59 13.17 35.75 13.12 35.9 13.06 36.01 13.02 36.08 12.99 36.14 12.96 36.24 12.91 36.37 12.85 36.51 12.79 36.61 12.73 36.69 12.67 36.76 12.61 36.85 12.54 36.96 12.47 37.07 12.39 37.17 12.31 37.26 12.21 37.35 12.11 37.44 12.01 37.53 11.9L36.49 11.9C36.25 11.9 36.04 11.83 35.87 11.68 35.71 11.54 35.6 11.35 35.56 11.11L34.5 4.39 37.45 4.39 37.84 9.94C37.84 10.1 37.92 10.18 38.08 10.18L38.56 10.18C39.26 8.62 39.79 6.69 40.14 4.39ZM47.32 1.32L46.19 9.35C46.15 9.58 46.17 9.73 46.26 9.81 46.34 9.89 46.53 9.94 46.82 9.94L47.44 9.94 47.59 11.78C47.18 11.99 46.53 12.1 45.64 12.1 44.87 12.1 44.29 11.91 43.89 11.52 43.5 11.14 43.34 10.62 43.42 9.95L44.62 1.32 47.32 1.32ZM50.6 1L51.68 1C52.25 1 52.51 1.29 52.45 1.86L52.35 2.65C52.28 3.15 51.98 3.4 51.47 3.4L50.36 3.4C49.8 3.4 49.55 3.12 49.62 2.54L49.72 1.76C49.76 1.25 50.06 1 50.6 1ZM51.03 11.9L48.34 11.9 49.37 4.39 52.06 4.39 51.03 11.9ZM56.33 9.24L54.67 8.67C53.45 8.24 52.92 7.42 53.09 6.19 53.18 5.49 53.48 4.98 54 4.66 54.52 4.34 55.37 4.17 56.55 4.17 57.98 4.2 59.18 4.31 60.14 4.51L59.9 6.16C58.61 6.14 57.66 6.13 57.04 6.13 56.48 6.13 56.11 6.14 55.94 6.17 55.77 6.2 55.68 6.28 55.66 6.4 55.65 6.52 55.69 6.61 55.8 6.68 55.9 6.76 56.11 6.84 56.42 6.94L58.13 7.5C59.35 7.9 59.89 8.68 59.76 9.83 59.65 10.73 59.3 11.32 58.73 11.62 58.15 11.92 57.26 12.07 56.06 12.07 54.89 12.07 53.7 11.97 52.51 11.76L52.73 10.12C52.85 10.12 53.21 10.12 53.81 10.12 54.4 10.13 54.86 10.13 55.16 10.13 55.97 10.13 56.5 10.11 56.75 10.06 57 10.01 57.14 9.91 57.16 9.77 57.17 9.66 57.13 9.57 57.03 9.51 56.93 9.45 56.69 9.36 56.33 9.24ZM64.85 6.11L64.41 9.35C64.37 9.59 64.38 9.75 64.45 9.82 64.52 9.9 64.68 9.94 64.94 9.94L65.87 9.94 66 11.76C65.42 11.99 64.66 12.1 63.72 12.1 62.99 12.1 62.43 11.9 62.04 11.51 61.66 11.11 61.52 10.59 61.62 9.92L62.17 6.11 60.87 6.11 61.08 4.46 62.42 4.39 62.72 2.36 65.39 2.36 65.11 4.39 67 4.39 66.76 6.11 64.85 6.11Z" id="StylistWP-Copy-10" fill="#FFFFFF"/><path d="M0.45 6.87C0.74 6.48 1.16 6.17 1.6 6.01 4.16 5.05 6.57 3.25 8.3 0.99 8.94 0.16 10.01-0.22 10.7 0.13 11.03 0.29 11.22 0.6 11.25 0.99 11.41 3.25 12.55 5.05 14.45 6.01 15.14 6.36 15.19 7.31 14.55 8.13 14.26 8.52 13.84 8.83 13.4 8.99 10.84 9.95 8.51 10.75 6.77 13.01 6.14 13.84 5.06 14.22 4.37 13.87 4.05 13.71 3.85 13.4 3.82 13.01 3.67 10.75 2.45 9.95 0.55 8.99 -0.14 8.64-0.19 7.69 0.45 6.87Z" id="Star-Copy-12" fill="#00B3E6"/></g></g></svg>'
		document.getElementById( 'wp-admin-bar-top-secondary' ).innerHTML += '<li class="stylist-topbar-logo"><a href="https://stylistwp.com/?ref=top-bar" target="_blank" class="ab-item">' + stylistLogo + ' <span class="stylist-badge"><b>•</b> MORE FEATURES</span></a></li>';
		*/
		/* const codeTextarea = document.getElementById( "stylist-css-code" )
		const codeStyleBlock = window.Stylist.iDoc.getElementById( 'stylist' )
		// Before initalizing codeEditor, fill the text are with css from <style id="stylist">
		if ( null !== codeStyleBlock ) {
			codeTextarea.value = codeStyleBlock.innerHTML
			codeStyleBlock.innerHTML = ''
		} */

		/**
		 * Convert styles in textarea #stylist-css-code into
		 * inline style block #stlst-css-data-full on editor init.
		 * Important: this function should follow codeEditor.on( 'change' ) block
		 * otherwise it will not work.
		 */
		/* const editorCSS = window.Stylist.codeManager.getValue()
		optimizeCodeWithPostCSS( editorCSS ) */

		// We don't want to register initial code formating in undo/redo history.
		/* window.Stylist.codeEditor.clearHistory() */
		// Update undo/redo icons
		// window.Stylist.updateHistory();
	}

	setSelectedEl = ( newSelectedEl ) => {
		// Reset current pseudo class to default state.
		this.onPseudoClassChange( 'none' )

		const cssCode = CodeManager.getCode()

		// Check if we already have cached selector as data attribute.
		let cssSelectorFull = newSelectedEl.getAttribute( 'data-cached-selector' )
		let cssSelectorCustom = newSelectedEl.getAttribute( 'data-cached-selector-custom' )

		// Need to close styles panel from here.
		this.setState( {
			sidebarTab: false,
		} );

		if ( null === cssSelectorFull ) {
			cssSelectorFull = getSelector( newSelectedEl )
			// Cache calcualted selector as data- attribute.
			newSelectedEl.setAttribute( 'data-cached-selector', cssSelectorFull )
		}

		if ( null === cssSelectorCustom ) {
			// Firstly select current element class/tag + parent class
			const cssSelectorFullParts = cssSelectorFull.split( ' ' )

			const lastSelectorItem = cssSelectorFullParts[ cssSelectorFullParts.length - 1 ]
			const beforeLastSelectorItem = cssSelectorFullParts[ cssSelectorFullParts.length - 2 ]

			if ( null !== lastSelectorItem ) {
				cssSelectorCustom = lastSelectorItem
			}

			if ( null !== beforeLastSelectorItem && ! cssSelectorCustom.includes( 'styled-' ) ) {
				cssSelectorCustom = beforeLastSelectorItem + ' ' + cssSelectorCustom
			}

			/**
			 * Before applying new selector path, try to find a more specific
			 * version of the same selector in the CSS code.
			 *
			 * For example:
			 * cssSelectorFull = "#page #main .styled-block-pbit .styled-heading-2-kfqt"
			 * cssSelectorCustom = ".styled-heading-2-kfqt"
			 * in CSS code we have ".styled-block-pbit .styled-heading-2-kfqt {...}"
			 * Then we should set cssSelectorCustom = ".styled-block-pbit .styled-heading-2-kfqt"
			 *
			 * Issue #21
			 */

			let modifiedCssSelectorCustom = ''

			if ( cssCode.includes( cssSelectorCustom ) ) {
				// Reverse the order of classes in the full selector
				// for easier processing.
				cssSelectorFullParts.reverse()

				forEach( cssSelectorFullParts, ( selector ) => {
					modifiedCssSelectorCustom = selector + ' ' + modifiedCssSelectorCustom

					if ( cssCode.includes( modifiedCssSelectorCustom ) ) {
						cssSelectorCustom = modifiedCssSelectorCustom
					}
				} )
			}

			cssSelectorCustom = cssSelectorCustom.trim();

			// Cache calcualted selector as data- attribute.
			newSelectedEl.setAttribute( 'data-cached-selector-custom', cssSelectorCustom )
		}

		this.setState( {
			selectedEl: newSelectedEl,
			cssSelectorFull: cssSelectorFull,
			cssSelectorCustom: cssSelectorCustom,
			sidebarTab: 'styling',
			selectorChanged: false,
			cssCacheReady: false,
		} )

		// Save selector as global var for legacy scripts.
		window.Stylist.selectedEl = newSelectedEl
		window.Stylist.cssSelectorCustom = cssSelectorCustom

		cacheCssValuesForSelector( {
			cssSelector: cssSelectorCustom,
			cssCode: cssCode
		} )

		this.updateUIOnSelect( newSelectedEl );
	}

	updateUIOnSelect = ( element = false ) => {
		if ( ! element ) {
			element = this.state.selectedEl
		}

		const elementJQ = jQuery( element )
		const bodyJQ = jQuery( document.body )
		const iframeDoc = window.frames.stylist_iframe.contentDocument;

		// RESIZE ELEMENTS
		window.visualResizingType = 'width';
		window.ResizeSelectedBorder = 'right';
		window.styleAttrBeforeChange = elementJQ.attr( 'style' );

		const elementOffset = elementJQ.offset();
		window.elementOffsetLeft = elementOffset.left;
		window.elementOffsetRight = elementOffset.right;

		elementJQ.width( parseFloat( elementJQ.width() + 10 ) );

		if ( window.elementOffsetLeft == elementOffset.left && window.elementOffsetRight != elementOffset.right ) {
			window.ResizeSelectedBorder = 'right';
		} else if ( window.elementOffsetLeft != elementOffset.left && window.elementOffsetRight == elementOffset.right && elementJQ.css( 'text-align' ) != 'center' ) {
			window.ResizeSelectedBorder = 'left';
		} else {
			window.ResizeSelectedBorder = 'right';
		}

		if ( window.stlst_legacy.isDefined( window.styleAttrBeforeChange ) ) {
			elementJQ.attr( 'style', window.styleAttrBeforeChange );
		} else {
			elementJQ.removeAttr( 'style' );
			window.styleAttrBeforeChange = null;
		}

		// Element selected.
		window.Stylist.iBodyJQ.addClass( 'stlst-content-selected' );

		window.orginalHeight = parseFloat( elementJQ.css( 'height' ).replace( /px/g, '' ) );
		window.orginalWidth = parseFloat( elementJQ.css( 'width' ).replace( /px/g, '' ) );

		if ( elementJQ.css( 'float' ) == 'right' ) {
			bodyJQ.addClass( 'stlst-element-float' );
		} else {
			bodyJQ.removeClass( 'stlst-element-float' );
		}

		// window.stlst_legacy.css_editor_toggle(true); // show if hide

		// Disable focus style after clicked.
		elementJQ.blur();

		// UPDATE UI.
		window.stlst_legacy.draw();
	}

	onInspectorToggle = () => {
		const newValue = this.state.inspectorActive === true ? false : true

		// Don't allow to disable inspector if no element choosen.
		// if ( ! newValue && ! this.state.selectedEl ) {
		// 	return false
		// }

		if ( newValue !== this.state.inspectorActive ) {
			this.setState( {
				inspectorActive: newValue,
				sidebarPanel: false,
			} )
		}

		// Clear selector box if some element already selected
		// on the moment we toggle inspector.
		if ( newValue === true && this.state.selectedEl ) {
			window.stlst_legacy.clean(); // Remove selector box.
		}
	}

	changeIframeResponsiveState = ( newState ) => {
		const previewIframe = document.getElementById( 'stylist_iframe' )
		if ( newState ) {
			// Responsive mode: ON.
			document.body.classList.add( 'stlst-responsive-device-mode' )

			// Recover iframe element style attribute (width)
			// from backup data-style attribute.
			const styleAttr = previewIframe.getAttribute( 'data-style' )
			previewIframe.removeAttribute( 'data-style' )
			previewIframe.setAttribute( 'style', styleAttr )
			document.querySelector( '.stylist-sidebar-wrapper' ).style.marginTop = '18px'
		} else {
			// Responsive mode: OFF.
			document.body.classList.remove( 'stlst-responsive-device-mode' )

			// Remove iframe element style attribute (width)
			// and backup it as data-style attribute.
			const styleAttr = previewIframe.getAttribute( 'style' )
			previewIframe.removeAttribute( 'style' )
			previewIframe.setAttribute( 'data-style', styleAttr )
			document.querySelector( '.stylist-sidebar-wrapper' ).style.marginTop = 'auto'
		}
	}

	onResponsiveModeToggle = () => {
		const newValue = this.state.responsiveView === true ? false : true

		if ( newValue !== this.state.responsiveView ) {
			const cachedCurrentTab = this.state.sidebarTab

			// Firstly, change the iframe width quickly.
			this.changeIframeResponsiveState( newValue )
			// Then, update the state and run other required actions.
			this.setState( {
				responsiveView: newValue,
				sidebarTab: false, // Disable sidebar to reset panel controls.
			}, () => {
				// Update responsive bars if responsive mode is active.
				if ( newValue ) {
					// This call should be called only once the new state is set.
					window.stlst_legacy.draw_responsive_handle();
				}
				// Actions to perform after state is set.
				window.stlst_legacy.updateResponsiveSizeNotice();

				// window.stlst_legacy.draw_box must process first. Fix "margin responsive update" problem
				window.stlst_legacy.draw_box();

				// draw all again now
				window.stlst_legacy.draw();

				window.stlst_legacy.updateResponsiveBreakpoints();

				this.setState( {
					// sidebarTab: true, // Re-enable sidebar.
					sidebarTab: cachedCurrentTab
				}, () => {

				} )
			} )
		}
	}

	toggleSaveHandler = () => {
		// If all changes already saved, So Stop.
		if ( ! this.state.codeChanged ) {
			return false
		}

		// Getting Page Id of the page being customized.
		let id = window.location.href.split( "&stlst_id=" )
		if ( window.stlst_legacy.isDefined( id[ 1 ] ) ) {
			id = id[ 1 ].split( "&" )
			id = id[ 0 ]
		} else {
			id = undefined
		}

		// Getting Post Type of the page being customized.
		let type = window.location.href.split( "&stlst_type=" )
		if ( window.stlst_legacy.isDefined( type[ 1 ] ) ) {
			type = type[ 1 ].split( "&" )
			type = type[ 0 ]
		} else {
			type = undefined
		}

		// Activate saving animation.
		this.setState( {
			isSaving: true,
		} )

		const editorCSS = CodeManager.getCode()
		optimizeCodeWithPostCSS( editorCSS ).then( ( response ) => {
			// @todo: get rid of jQuery here.
			const posting = jQuery.post( ajaxurl, {
				action: "stlst_ajax_save",
				stlst_id: id,
				stlst_stype: type,
				stlst_data: response,
				post_content: window.Stylist.iBody.innerHTML,
			} )

			// Done.
			posting.complete( jQuery.proxy( function() {
				this.setState( {
					codeChanged: false,
					isSaving: false,
				} )
			}, this ) )
		} )
	}

	onCssSelectorChange = ( newSelector ) => {
		// @todo: add inspector refocusing based on new selector.
		// only if returned for new selector elements has not .stylist-selected class?

		// Ignore pseudo class changes.
		if ( newSelector.includes( ':' ) ) {
			return false
		}

		newSelector = newSelector.trim()
		const newSelectedEls = window.Stylist.iBody.querySelectorAll( newSelector )
		const sameEl = find( newSelectedEls, function( el ) {
			return el.classList.contains( 'stlst-selected' );
		} );

		if ( undefined === sameEl && newSelectedEls[ 0 ] ) {
			// Update cache with all new values for the current selector.

			// Cache custom selector to make sure Stylist don't calculate it again.
			newSelectedEls[ 0 ].setAttribute( 'data-cached-selector-custom', newSelector )

			// Check if we arealy called the right inspect methods required
			// on every element change.
			if ( ! newSelectedEls[ 0 ].classList.contains( 'stlst-selected' ) ) {
				window.stlst_legacy.clean(); // Remove current selector box.
				// Update this.state.selectedEl early so <Inspector> can catch it
				// and perform the right actions before running this.setSelectedEl.
				this.setState( {
					selectedEl: newSelectedEls[ 0 ],
					selectorChanged: true,
					sidebarPanel: false,
				} )
			} else {
				this.setSelectedEl( newSelectedEls[ 0 ] )
			}
		} else {
			// Cache calcualted selector as data- attribute.
			this.state.selectedEl.setAttribute( 'data-cached-selector-custom', newSelector )

			// Replace old selector with new in all instances CSS code:
			const cssCode = CodeManager.getCode()
			const result = replaceSelectorInCss( this.state.cssSelectorCustom, newSelector )
			// window.Stylist.codeManager.setValue( result )
			CodeManager.setCode( result )

			// Save selector as global var for legacy scripts.
			window.Stylist.selectedEl = this.state.selectedEl
			window.Stylist.cssSelectorCustom = newSelector

			this.setState( {
				cssSelectorCustom: newSelector,
			} )
		}
	}

	onPseudoClassChange = ( newPseudoClass ) => {
		// Don't proceed if nothing changed.
		if ( newPseudoClass === this.state.cssCurrentPseudoClass ) {
			return false
		}

		this.setState( {
			cssCurrentPseudoClass: newPseudoClass,
			sidebarTab: false,
		} )

		this.setState( {
			sidebarTab: true,
		} )

		// Save selector as global var for legacy scripts.
		window.Stylist.cssCurrentPseudoClass = newPseudoClass

		// Firstly, remove previously set pseudo classes.
		this.removePseudoClasses()

		if ( this.state.selectedEl ) {
			// Secondly, apply new pseudo-class marker to the selected element.
			if ( newPseudoClass === 'hover' ) {
				this.state.selectedEl.classList.add( 'stlst-hover' )
			} else if ( newPseudoClass === 'active' ) {
				this.state.selectedEl.classList.add( 'stlst-active' )
			} else if ( newPseudoClass === 'focus' ) {
				this.state.selectedEl.classList.add( 'stlst-focus' )
			}
		}
	}

	removePseudoClasses = () => {
		forEach( window.Stylist.iDoc.querySelectorAll( '.stlst-hover' ), function( el ) {
			el.classList.remove( 'stlst-hover' )
		} );

		forEach( window.Stylist.iDoc.querySelectorAll( '.stlst-active' ), function( el ) {
			el.classList.remove( 'stlst-active' )
		} );

		forEach( window.Stylist.iDoc.querySelectorAll( '.stlst-focus' ), function( el ) {
			el.classList.remove( 'stlst-focus' )
		} );
	}

	onSidebarTabChange = ( newId ) => {
		this.setState( {
			sidebarTab: newId,
		} )

		if ( 'code' !== newId && null !== window.Stylist.codeEditor && undefined !== window.Stylist.codeEditor  ) {
			// Destroy CodeEditor instance.
			window.Stylist.codeEditor.getWrapperElement().parentNode.innerHTML = ''
			window.Stylist.codeEditor = null
		}

		// Call the functiont to optimize css code after
		// user manually edited CSS code.
		if ( 'styling' === newId ) {
			// Reset cached CSS values.
			window.Stylist.setCssCacheReady( false )
			window.Stylist.cachedCssValues = {}
			// Build CSS values cache again.
			cacheCssValuesForSelector( {
				cssSelector: this.state.cssSelectorCustom,
				cssCode: CodeManager.getCode()
			} )
		} else if ( 'code' === newId ) {
			// .stylist-sidebar--code
			const codeEditorPlaceholder = document.getElementById( "stylist-sidebar--code-editor" )

			const codeTextarea = document.getElementById( "stylist-css-code" )
			window.Stylist.codeEditor = wp.CodeMirror( codeEditorPlaceholder, {
				// value: "Nullam id dolor id nibh ultricies vehicula ut id elit. Cras mattis consectetur purus sit amet fermentum. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nulla vitae elit libero, a pharetra augue.",//CodeManager.getCode(),
				autoRefresh: true,
				lineNumbers: true,
				mode: "css",
				undoDepth: 10,
				indentUnit: 2,
				tabSize: 2,
				indentWithTabs: true,
				// gutters: [ "CodeMirror-lint-markers" ],
				matchBrackets: true,
				autoCloseBrackets: true,
				continueComments: true,
			} )

			window.Stylist.codeEditor.doc.setValue( CodeManager.getCode() )
			// https://github.com/codemirror/CodeMirror/wiki/CodeMirror-addons
			// https://make.wordpress.org/core/2017/10/22/code-editing-improvements-in-wordpress-4-9/
			/*
			window.Stylist.codeEditor = wp.CodeMirror.fromTextArea( codeTextarea, {
				lineNumbers: true,
				mode: "css", //text/css
				lint: false, // Disabled for now. Need to make it work properly first.
				// Create custom linter to disable some unwanted error messages:
				// https://stackoverflow.com/questions/41534824/codemirror-get-linting-result-from-outside-of-the-editor?rq=1
				// lint: {
					// getAnnotations: this.customCssLinter,
					// formatAnnotation: this.formatAnnotation,
					// async: true,
				// },
				undoDepth: 10,
				indentUnit: 2,
				tabSize: 2,
				indentWithTabs: true,
				gutters: [ "CodeMirror-lint-markers" ],
				matchBrackets: true,
				autoCloseBrackets: true,
				continueComments: true,
				// @todo: figure out how to make csslint customization work.
				// https://github.com/CSSLint/csslint/wiki/Rules
				// csslint: {
					// "order-alphabetical": true,
					// "warnings":false,
					// "errors":false, 
				// 	"box-model":true,
				// 	"display-property-grouping":true,
				// 	"duplicate-properties":true,
				// 	"known-properties":true,
				// 	"outline-none":true
				// },
				// extraKeys:{
				// 	"Ctrl-Space":"autocomplete",
				// 	"Ctrl-\/":"toggleComment",
				// 	"Cmd-\/":"toggleComment",
				// 	"Alt-F":"findPersistent",
				// 	"Ctrl-F":"findPersistent",
				// 	"Cmd-F":"findPersistent"
				// },
			} )

			*/
			window.Stylist.codeEditor.on( 'change', ( instance ) => {
				CodeManager.setCode( instance.doc.getValue() )
			} )

			window.Stylist.codeEditor.on( 'update', ( instance ) => {
				// throttledOnCodeEditorChange( instance )
			} )

			/* window.Stylist.codeEditor.defineInitHook( ( instance ) => {
				// throttledOnCodeEditorChange( instance )
			} ) */
		}
	}

	onPanelChange = ( newId ) => {
		if	( newId === this.state.sidebarPanel ) {
			if ( ! newId.includes( '/' ) ) {
				newId = false
			} else {
				const panelIds = newId.split( '/' )
				newId = panelIds[ 0 ]
			}
		}

		this.setState( {
			sidebarPanel: newId,
		} )
	}

	onFullScreenToggle = () => {
		let newFullscreenState = false
		if ( ! this.state.isFullScreen ) {
			newFullscreenState = true
		}

		this.setState( {
			isFullScreen: newFullscreenState,
		} )
	}

	onCurrentMediaTypeChange = ( newMediaType ) => {
		// Do nothing if value didn't change.
		if ( newMediaType === this.state.currentMediaType ) {
			return
		}

		this.setState( {
			currentMediaType: newMediaType,
		}, () => {
			// Once the state updated update UI based on new media type.
			window.stlst_legacy.updateResponsiveSizeNotice();
			window.stlst_legacy.updateResponsiveBreakpoints();
		} )
	}

	render() {
		return (
			<div className="stylist-root">
				<Header
					codeChanged={this.state.codeChanged}

					responsiveView={this.state.responsiveView}
					inspectorActive={this.state.inspectorActive}
					selectedEl={this.state.selectedEl}
					cssSelectorFull={this.state.cssSelectorFull}
					cssSelectorCustom={this.state.cssSelectorCustom}
					cssCurrentPseudoClass={this.state.cssCurrentPseudoClass}
					isSaving={this.state.isSaving}
					isFullScreen={this.state.isFullScreen}

					onCssSelectorChange = { this.onCssSelectorChange }
					onPseudoClassChange = { this.onPseudoClassChange }
					onInspectorToggle={this.onInspectorToggle}
					onResponsiveModeToggle={this.onResponsiveModeToggle}
					onFullScreenToggle={this.onFullScreenToggle}
					onSave={this.toggleSaveHandler} />
				{<Sidebar
					inspectorActive={this.state.inspectorActive}
					selectedEl={this.state.selectedEl}
					cssSelectorFull={this.state.cssSelectorFull} // Delete?
					cssSelectorCustom={this.state.cssSelectorCustom}
					cssCurrentPseudoClass={this.state.cssCurrentPseudoClass}
					currentPreviewWidth={this.state.currentPreviewWidth}
					cssCacheReady = {this.state.cssCacheReady}

					sidebarTab={this.state.sidebarTab}
					currentSidebarPanel={ this.state.sidebarPanel }
					onSidebarTabChange={this.onSidebarTabChange}
					onPanelChange={this.onPanelChange}
					onResponsiveModeToggle={this.onResponsiveModeToggle}

					onCssSelectorChange = { this.onCssSelectorChange } /> }
				<div id="popup-root"></div>
				<div id="preview-cover"></div>
				<textarea name="stylist-css-code" id="stylist-css-code" cols="30" rows="10"></textarea>
				<Inspector
				// {...this.state}
					inspectorActive={this.state.inspectorActive}
					selectedEl={this.state.selectedEl}
					responsiveView={this.state.responsiveView}

					onInspectorToggle={this.onInspectorToggle}
					onElementSelected={this.setSelectedEl} />

				<ResponsiveControls
					currentMediaType={this.state.currentMediaType}
					onCurrentMediaTypeChange={this.onCurrentMediaTypeChange}
				/>
				<DisableLinkClick
					inspectorActive={this.state.inspectorActive}
					isSaving={this.state.isSaving }
					codeChanged={this.state.codeChanged} />
			</div>
		)
	}
}

export default App



// WEBPACK FOOTER //
// ./dev/stylist_parent/editor/app/index.jsx